import { ExpirationDate } from '@arc/unified-payments-frontend/date-utils';
import { RetrieveAuthorizationVerbiageResponseV1 } from '@arc/unified-payments-frontend/shared-payment';
import { createAction, props, union } from '@ngrx/store';

export const surchargeAuthVerbiageRetrieved = createAction(
  '[POI Payment - Select Payment Method] Surcharge Auth Verbiage Retrieved',
  props<{
    payload: RetrieveAuthorizationVerbiageResponseV1;
  }>(),
);

export const paymentAccountSelected = createAction(
  '[POI Payment - Select Payment Method] Payment Account Selected',
);

export const paymentAccountExpirationDateUpdated = createAction(
  '[POI Payment - Select Payment Method] Payment Account Expiration Date Updated',
  props<{
    paymentAccountIdentifierBurn: string;
    expirationDate: ExpirationDate;
  }>(),
);

export const paymentAccountDeleted = createAction(
  '[POI Payment - Select Payment Method] Payment Account Deleted',
  props<{
    paymentAccountBurn: string;
  }>(),
);

export const selectedPaymentAccountDeleted = createAction(
  '[POI Payment - Select Payment Method] Selected Payment Account Deleted',
);

const PoiBtPaySelectPaymentMethodActions = union({
  surchargeAuthVerbiageRetrieved,
  paymentAccountSelected,
  paymentAccountDeleted,
});

export type PoiBtPaySelectPaymentMethodActionsUnion =
  typeof PoiBtPaySelectPaymentMethodActions;
